import _ from 'lodash';
import qs from 'query-string';

import { comparablesMappingHandler } from 'components/tracking/TrackingUtils';

export function onApplyTrack (props, data) {
  if (!_.isEmpty(data)) {
    const { track } = props;
    const { intent, product } = data;
    const {
      productName,
      promotional,
      __typename,
      comparables,
      provider,
      title,
    } = product;

    let type;
    if (promotional) {
      const { type: promotionalType } = promotional;
      type = promotionalType;
    } else {
      type = [];
    }
    const productDetails = comparables?.map(comparablesMappingHandler).join('|');
    const { displayValue, prefix, __typename: comparablesTypeName } = _.last(comparables) ?? [];

    let currency = '';
    let price = '';
    if (comparablesTypeName === 'CompareElementPrice') {
      currency = prefix;
      price = displayValue;
    }

    const trackingData = {};

    trackingData.event = 'productClick';
    trackingData.ecommerce = {
      click: {
        products: [{
          name: productName,
          id: title || '',
          price: price || '',
          currency: currency || '',
          brand: provider ? provider.providerName : '',
          category: __typename,
          purchaseIntent: intent,
          promotion: (type) ? type.map(t => t.key).join('|') : '',
          promoLabel: (type) ? type.map(t => t.display).join('|') : '',
          dealStatus: 'true',
          productDetails,
          position: '',
        }],
      },
    };

    track({ data: trackingData });
  }
}

export function productPageLoadTrack(data) {
  if (!_.isEmpty(data)) {
    const { props } = data;
    const {
      track,
      product,
      location,
    } = props;

    const {
      productName,
      promotional,
      __typename,
      comparables,
      provider,
      title,
    } = product;
    const { search } = location;
    const { from, entry } = search && qs.parse(search);

    let type;
    if (promotional) {
      const { type: promotionalType } = promotional;
      type = promotionalType;
    } else {
      type = [];
    }
    const productDetails = (comparables) ? comparables.map(comparablesMappingHandler).join('|') : '';
    const {
      displayValue,
      prefix,
      __typename: comparablesTypeName,
    } = (comparables) ? _.last(comparables) : {};

    let currency = '';
    let price = '';
    if (comparablesTypeName === 'CompareElementPrice') {
      currency = prefix;
      price = displayValue;
    }

    const trackingData = {};

    trackingData.ecommerce = {
      detail: {
        actionField: { list: from, entry },
        products: [{
          name: productName,
          id: title || '',
          price: price || '',
          currency: currency || '',
          brand: provider ? provider.providerName : '',
          category: __typename,
          purchaseIntent: '',
          promotion: (type) ? type.map(t => t.key).join('|') : '',
          promoLabel: (type) ? type.map(t => t.display).join('|') : '',
          dealStatus: 'true',
          productDetails,
          position: '',
        }],
      },
    };

    track({ data: trackingData });
  }
}
